import WidgetReservationListPagingResultModelBase from '../_generated/modelBases/widget-reservation-list-paging-result-model-base';

export default class WidgetReservationListPagingResultModel extends WidgetReservationListPagingResultModelBase {
  // For instructions on how to use Models visit:
  // https://glittrsoftware.visualstudio.com/glittr.core/_wiki/wikis/glittr.core.wiki/429/ServiceModels-DTOs
}
